import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, Input, ElementRef, forwardRef } from '@angular/core';

import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'finder-focus-input',
    templateUrl: './focus-input.component.html',
    styleUrls: ['./focus-input.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule
    ],
    providers : [{
        provide : NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FocusInputComponent),
        multi : true,
    }]
})
export class FocusInputComponent implements ControlValueAccessor {
    @Output() focused = new EventEmitter();
    @Input() label: string;

    active = false;

    private _value: string;
    @Input()
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    private _disabled: boolean;
    get disabled() {
        return this._disabled;
    }

    private onChange;
    private onTouched;

    constructor(
        private elementRef: ElementRef,
    ) {
        this.onChange = () => {};
        this.onTouched = () => {};
        this.setDisabledState(false);
    }

    setDisabledState(isDisabled: boolean) {
        this._disabled = isDisabled;
    }

    onFocus() {
        if (this.disabled) {
            return;
        }

        this.focused.emit(true);
        this.active = true;
        this.getInput().select();
    }

    onFocusout() {
        if (this.disabled) {
            return;
        }

        this.focused.emit(false);
        this.active = !!this._value;
    }

    setFocus() {
        if (this.disabled) {
            return;
        }

        this.getInput().focus();
    }

    // Interface implementation for reactive forms
    /* istanbul ignore next */
    writeValue(value: string) {
        if (this.disabled) {
            return;
        }

        this.onChange(value);
        this.onTouched();
    }

    // Interface implementation for reactive forms
    /* istanbul ignore next */
    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    // Interface implementation for reactive forms
    /* istanbul ignore next */
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    private getInput() {
        return this.elementRef.nativeElement.querySelector('input.input');
    }
}
